import React from 'react';
import PropTypes from 'prop-types';

import { ActionItemNote, ActionItemNoteCell } from './HistoryDetail.styles';

const HistoryNoteContent = ({ content }) => (
  <ActionItemNote>
    <ActionItemNoteCell>{content}</ActionItemNoteCell>
  </ActionItemNote>
);

HistoryNoteContent.propTypes = {
  content: PropTypes.string
};

export default HistoryNoteContent;
